import { QualityService } from './quality-service.model';
import { VesselType } from '../../shared/models/vessel-type.modal';
import { AcceptanceCriteria } from './acceptence-criteria.model';
//import { MachineType } from './machine-type.model';
//import { BaseType } from 'src/app/shared/models/enums.model';
import { Attachment } from '../../shared/models/attachment.model';
import { TypeOfMagent } from './type-of-magent.model';
import { MaterialForm } from './material-form.model';
import { FilmType } from './film-type.model';
import { NearestLocation, BaseTypeId, NearestLocationForDynamicBalancing } from 'src/app/shared/models/enums.model';
import { LookUp } from '../../shared/models/look-up.model';
import { EquipmentType } from './machine-type.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';

export class QualityRequestDTO{
  ServiceId :number;
  RequestorId:string;
  QualityService:QualityService;
  QualityServiceId?:number;
  VesselType:VesselType;
  VesselTypeId:number;
   AcceptanceCriteria:AcceptanceCriteria;
   AcceptanceCriteriaId?:number;
   Description:string;
   Attachments:Attachment[]= [];
   GraphicsImplementation:string;//attachment
   DateOfMeasurement?:Date;
   MachineType:EquipmentType;
   MachineTypeId?:number;
   BaseTypeId:BaseTypeId;
   CouplingType:string;
   RPM:string;
   KW:string;
   KWUnit?:number;
   Details:string;
   DesiredDate?:Date;
   Cleaner:string;
  Penetrant:string;
  Developer:string;
  TypeOfMagnetId?:number;
  TypeOfMagnet:TypeOfMagent;
  WhiteBackground :string;
  BlackInk:string;
  MaterialFormId?:number;
  MaterialForm:MaterialForm;
  FilmTypeId?:number;
  FilmType:FilmType;
  MaterialThickness:string;
  MaterialThicknessUnit?:number;
  NearestLocation :NearestLocationForDynamicBalancing;
  VesselName:string;
  MaterialType:string;
  MeasurementUnit:LookUp;
  MeasurementUnitId:number;
  Fax:string;
  MobileNumber:string;
  CustomerName:string;
  Drawings:string;
  TypeOfUnitId:number;
  UnitWeight:string;
  OperatingSpeed:string;
  OthersAcceptanceCriteria:string;
  OthersMachineType:string;
  OthersTypeOfUnit:string;
  baseRequest :BaseRequest;
}
